// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hxU5","toggle":"styles_toggle__NFZ8w","preview":"styles_preview__1C_pC"};